<template>
    <div class="rule-wrapper">
        <h3 class="rule-title">{{activityData.title}}</h3>
        <div class="rule-desc" v-html="activityData.desc"></div>
    </div>
</template>

<script>
import COVER from '@/utils/COVER'
import COVERAPP from '@/utils/COVERAPP'
import { mapState, mapActions } from 'vuex'

export default {
    props: ['activityData', 'baseData'],
    computed: {
		...mapState(['dialogData', 'userInfo', "aid"]),
	},
    mounted() {
        if(COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
            this.getUserInfon() 
        }
        this.share();
        setTimeout(()=> {
            this.setPageLoadingAsync(false);
        }, 500);
    },
    methods: {
        ...mapActions([
            'setPageLoadingAsync',
            'setDialogDataAsync',
            'setUserInfoAsync'
		]),
        getUserInfon() {
            this.setUserInfoAsync();    
        },
        //分享
        share() {
            let data = this.baseData.share;
            let shareData = {
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl,
                link: window.location.href
            }
            COVER.share(shareData)
        },
    }
}
</script>

<style lang="less">
.rule-wrapper {
    padding: .2667rem 0 1rem;
}
.rule-title {
    text-align: center;
    font-size: .5rem;
    padding: .2rem .3rem;
    line-height: 1.5em;
    font-weight: normal;
}
.rule-desc {
    font-size: .4rem;
    padding: 0 0.3rem;
    line-height: 1.3;
}
</style>